<div [ngClass]="!(fromTab == 'STab') ? 'img-container-PD' : 'img-container'" class="img-container"
  [style.backgroundColor]="config.containerBackgroundColor" (wheel)="scrollZoom($event)">
  <img #imgRef [src]="src[index]" [ngStyle]="style" alt="Image not found..." [draggable]="false"
    [style.cursor]="panning ? 'grabbing' : 'grab'" (pointerdown)="onPointerDown($event)"
    (pointermove)="onPointerMove($event)" (pointerup)="onPointerUp($event)"
    (pointercancel)="onPointerUp($event)"
    (load)="onLoad()" (loadstart)="onLoadStart()" />
    <!-- Div below will be used to hide the 'ghost' image when dragging -->
    <div></div>
    @if (loading) {
      <!-- <div class="spinner-container">
        <div class="spinner"></div>
      </div> -->
    }


    <button type="button" [class]="config.btnClass" (click)="fireCustomEvent('Reset', index)" pInputText
      [pTooltip]="'Reset'" tooltipPosition="left">
      <span [class]="'pi pi-sync'"></span>
    </button>
    @if (config.btnShow?.zoomOut) {
      <button type="button" [class]="config.btnClass" (click)="zoomOut()" pInputText
        pTooltip="Zoom out" tooltipPosition="left">
        <span [class]="config.btnIcons?.zoomOut"></span>
      </button>
    }

    @if (config.btnShow?.zoomIn) {
      <button type="button" [class]="config.btnClass" (click)="zoomIn()" pInputText
        pTooltip="Zoom in" tooltipPosition="left">
        <span [class]="config.btnIcons?.zoomIn"></span>
      </button>
    }
    @if (config.btnShow?.rotateCounterClockwise) {
      <button type="button" [class]="config.btnClass"
        (click)="rotateCounterClockwise()" pInputText pTooltip="Rotate left" tooltipPosition="left">
        <span [class]="config.btnIcons?.rotateCounterClockwise"></span>
      </button>
    }
    @if (config.btnShow?.rotateClockwise) {
      <button type="button" [class]="config.btnClass" (click)="rotateClockwise()"
        pInputText pTooltip="Rotate right" tooltipPosition="left">
        <span [class]="config.btnIcons?.rotateClockwise"></span>
      </button>
    }
    @for (cBtn of config.customBtns; track cBtn) {
      <button type="button" [class]="config.btnClass"
        (click)="fireCustomEvent(cBtn.name, index)" pInputText [pTooltip]=cBtn.name tooltipPosition="left">
        <span [class]="cBtn.icon"></span>
      </button>
    }

    @if (config.allowFullscreen) {
      <button type="button" id="ngx-fs-btn" [class]="config.btnClass" (click)="toggleFullscreen()"
        >
        <span [class]="config.btnIcons?.fullscreen"></span>
      </button>
    }
    @if (fromTab == 'STab') {
      <button type="button" [class]="config.btnClass" (click)="downloadCanvasImage()" pInputText pTooltip="Crop image"
        tooltipPosition="left" [disabled]="!showRerenderedImageDownload || !canvasImageIsOriginClean">
        <span [class]="'pi pi-crop'"></span>
      </button>
    }
  </div>